import React from "react";
import { useSelector } from "react-redux";
import UpgradeAnalytics from "./UpgradeAnalytics";
import ProAnalytics from "./ProAnalytics";

const Analytics = () => {
  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );
  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );

  // FAQ
  const analyticsCheck = blockFeature?.some(
    (item) => item.name === "Analytics" && paymenetBlocks === 1
  );

  return <>{analyticsCheck ? <ProAnalytics /> : <UpgradeAnalytics />}</>;
};
export default Analytics;
